module.exports = __webpack_public_path__ + "media/fonts/Aleo-BoldItalic-fff41862970d55eb6238319c06b31638.ttf";